import { Injectable } from '@angular/core';

/**
 * Remembers the screen that started a load flow so every exit of the guided loading screens
 * (finish, cancel, timeout, error) goes back to it. The guided screens are shared between
 * front-loading, rear-loading and the employee UI, so the destination cannot be derived from the
 * route or the device: only the origin knows it.
 *
 * The origin is a one-shot token: the first exit consumes it and the flow goes back to its default
 * destination from then on.
 */
@Injectable({ providedIn: 'root' })
export class LoadFlowOriginService {
  private returnUrl: string | null = null;

  /** Marks the screen the load flow is starting from. */
  start(returnUrl: string): void {
    this.returnUrl = returnUrl;
  }

  /** Whether the current load flow was started by a screen that owns its exit. */
  get hasOrigin(): boolean {
    return this.returnUrl !== null;
  }

  /** The origin, once, or the destination the flow would use when it started somewhere else. */
  consumeExit(defaultUrl: string): string {
    const origin = this.returnUrl;
    this.clear();
    return origin ?? defaultUrl;
  }

  clear(): void {
    this.returnUrl = null;
  }
}
